export const EARTH_RADIUS_KM = 6371;
export const ONE_MINUTE = 60 * 1000;
export const FIFTEEN_MINUTES = 15 * 60 * 1000;
export const HALF_HOUR = 30 * 60 * 1000;
export const ONE_HOUR = 60 * 60 * 1000;
export const TWENTYFOUR_HOURS = 24 * 60 * 60 * 1000;
export const ONE_WEEK = 7 * 24 * 60 * 60 * 1000;
export const ONE_MONTH = 31 * 24 * 60 * 60 * 1000;
export const HALF_YEAR = 182 * 24 * 60 * 60 * 1000;
export const FOUR_YEAR = 4 * 365 * 24 * 60 * 60 * 1000;